import LayoutPage from '@/components/Layout/LayoutPage';
import ExpertPaymentsConsole from '@/features/expert-payments/ExpertPaymentsConsole';
import { useExpertPaymentsConsoleEnabled } from '@/features/expert-payments/featureFlag';
import NotFoundPage from '@/pages/NotFoundPage';

/**
 * `/admin/expert-payments` — the internal accounts-payable console.
 *
 * The gate is checked here rather than in the route table (the
 * `ApprovalsRoute` convention) so flipping the environment variable takes effect
 * without rebuilding the route tree, and so the dark case renders the standalone
 * 404 — `NotFoundPage` brings its own `Layout`, and nesting it inside
 * `LayoutPage` would double-wrap the chrome.
 *
 * This is only the feature gate. Reach is enforced by `superAdminRequiredLegacy`
 * on the route, which asks the api; the ability to move money is enforced by the
 * api again on each mutation.
 */
export default function ExpertPaymentsRoute(): JSX.Element {
  if (!useExpertPaymentsConsoleEnabled()) return <NotFoundPage />;
  return (
    <LayoutPage showNav>
      <ExpertPaymentsConsole />
    </LayoutPage>
  );
}
